module.exports = __webpack_public_path__ + "static/media/tablet.ef5f5580.svg";